import parse from 'html-react-parser';

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 1,
        paritialVisibilityGutter: 0
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 1,
        paritialVisibilityGutter: 0
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
        paritialVisibilityGutter: 0
    }
};

export default function TestimonialSlider(props) {
    const { 
        testimonials, 
        backgroundColor, 
        textColor
    } = props.blockInfo;
    
    return (
        <div className='mx-auto w-full'>
            <Carousel
                partialVisbile
                containerclassName='w-full'
                responsive={responsive}
                swipeable={false}
                draggable={false}
                autoPlay={testimonials && testimonials.length > 1}
                arrows={testimonials && testimonials.length > 1}
                infinite={true}
                autoPlaySpeed={7000}
            >
                {testimonials && testimonials.map((item, index) => (
                    <section 
                        key={index}
                        className="overflow-hidden h-full flex items-center" 
                        style={{
                            backgroundColor: backgroundColor,
                            color: textColor
                        }} 
                    >
                        <div className="relative mx-auto max-w-7xl px-6 pt-20 pb-12 lg:px-8 lg:py-20">
                            <div className={`relative lg:flex lg:items-center ${item.imagePosition === 'right' ? 'lg:flex-row-reverse' : ''}`}>
                                {item.image && (
                                    <div className="hidden lg:block lg:flex-shrink-0">
                                        <img
                                            className="h-64 w-64 rounded-full xl:h-80 xl:w-80 object-cover"
                                            src={item.image.url}
                                            alt=""
                                            loading='lazy'
                                        />
                                    </div>
                                )}
                                <div className="relative lg:ml-10">
                                    <svg
                                        className={`absolute top-0 h-36 w-36 -translate-x-8 -translate-y-24 transform text-gray-400 opacity-50 ${item.imagePosition === 'left' ? '-scale-y-100 -scale-x-100 right-0' : 'left-0'}`}
                                        stroke="currentColor"
                                        fill="none"
                                        viewBox="0 0 144 144"
                                        aria-hidden="true"
                                    >
                                        <path
                                            strokeWidth={2}
                                            d="M41.485 15C17.753 31.753 1 59.208 1 89.455c0 24.664 14.891 39.09 32.109 39.09 16.287 0 28.386-13.03 28.386-28.387 0-15.356-10.703-26.524-24.663-26.524-2.792 0-6.515.465-7.446.93 2.327-15.821 17.218-34.435 32.11-43.742L41.485 15zm80.04 0c-23.268 16.753-40.02 44.208-40.02 74.455 0 24.664 14.891 39.09 32.109 39.09 15.822 0 28.386-13.03 28.386-28.387 0-15.356-11.168-26.524-25.129-26.524-2.792 0-6.049.465-6.98.93 2.327-15.821 16.753-34.435 31.644-43.742L121.525 15z"
                                        />
                                    </svg>
                                    <blockquote className="relative">
                                        <div className="text-2xl font-medium leading-9">
                                            {parse(item.endorsement ?? '')}
                                        </div>
                                        {item.image && (
                                            <div className="mt-8">
                                                <div className="flex"   style={{
                                                    backgroundColor: backgroundColor,
                                                    color: textColor
                                                }}>
                                                    <div className="flex-shrink-0 lg:hidden">
                                                        <img
                                                            className="h-12 w-12 rounded-full object-cover"
                                                            src={item.image.url}
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="ml-4 lg:ml-0">
                                                        <div className="text-base font-bold">{item.fullName}</div>
                                                        <div className="text-base font-bold">{item.fullTitle}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </blockquote>
                                </div>
                            </div>
                        </div>
                    </section>
                ))}
            </Carousel>
        </div>
    )
}
